module.exports = __webpack_public_path__ + "static/media/M3_Logo02_FOR-WEB.b66bffda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/M3_Logo02_FOR-WEB.jpg
// module id = 710
// module chunks = 0